// extracted by mini-css-extract-plugin
export default {"menu":"menu_menu__QMw-8"};